// JobList.js

import React, { useState } from 'react';
import '../JobList.css'; // Import the CSS file
import { BASE_URL } from '../constants';
import { Alert, Modal, Button, Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const jobs = [
  {
    id: 'JB12098',
    title: 'UI Developer',
    postedDate: 'Jan 15, 2025',
    description: "Job Details:\n 0-3yrs yrs exp Entry Level UI Developer, Passionate about Programming and knowledge in Java programming language with good command in OOPS concepts, Project: Knowledge in REACT / ANGULAR and NODE JS and should have done at least one academic project in HTML, JS, REACT, ANGULAR, Frameworks: Knowledge of Java frameworks like ANGULAR, JQUERY, Structs, Node js, CSS, BOOTSTRAP or others is a plus, WebDevelopment: Experience in developing web applications or web sites using HTML, CSS, JavaScript, jQuery and Ajax is preferred, Microservices: Good understanding of Microservice, Cloud: Exposure to AWS or other cloud platforms, Communication: Should have strong communication skills",
    email: 'hr@iqubeinc.com',
  },
  {
    id: 'JB12099',
    title: 'Mid Level Java developer',
    postedDate: 'Jan 17, 2025',
    description: "Job Details:\n 2-5yrs yrs exp Entry Level Java Developer, Passionate about Programming and knowledge in Java programming language with good command in OOPS concepts, Project: Knowledge in Java and SQL and should have done at least one academic project in Java, Frameworks: Knowledge of Java frameworks like JSP, Structs, Spring, Hibernate or others is a plus, WebDevelopment: Experience in developing web applications or web sites using HTML, CSS, JavaScript, jQuery and Ajax is preferred, Microservices: Good understanding of Microservice, Cloud: Exposure to AWS or other cloud platforms, Communication: Should have strong communication skills",
    email: 'hr@iqubeinc.com',
  },
  {
    id: 'JB13000',
    title: "Entry Level Java Developer",
    postedDate: "Jan 20, 2025",
    description: "Job Details:\n 0-3yrs yrs exp Entry Level Java Developer, Passionate about Programming and knowledge in Java programming language with good command in OOPS concepts, Project: Knowledge in Java and SQL and should have done at least one academic project in Java, Frameworks: Knowledge of Java frameworks like JSP, Structs, Spring, Hibernate or others is a plus, WebDevelopment: Experience in developing web applications or web sites using HTML, CSS, JavaScript, jQuery and Ajax is preferred, Microservices: Good understanding of Microservice, Cloud: Exposure to AWS or other cloud platforms, Communication: Should have strong communication skills",
    email: 'hr@iqubeinc.com'
  },  
  {
    id: 'JB13001',
    title: 'Java Developer',
    postedDate: 'Jan 10, 2025',
    description: 'Job Details:\n7+ years of Core Java development experience, familiar with Java 7 or higher. Experience with Java development and awareness of Java patterns. Experience in Microservices, Spring Boot used for development. Experience in development projects and developed functionalities using Java, J2EE. Experience in Angular 2+ development. Experience in Cucumber automation test cases. Must have AWS experience. AWS services (S3, SQS, SNS, ECS, Lambda, AWS CloudWatch, etc.). Experience on AWS deployed applications. Experience on Oracle or Postgres or DynamoDB to perform SQL. Agile/Scrum development experience. Good collaboration and communication skills. Ready to learn new technologies and perform POC on them. Ability to diagnose production issues and defects.\nExperience:\n9+ years of experience.\nMust-Haves:\nJava.\nAWS.\nAngular.\nSkills:\nJava, Core Java, Java 7+, Angular 2+, Microservices, Spring Boot, Cucumber, AWS services (S3, SQS, SNS, ECS, Lambda, AWS CloudWatch, etc.), Oracle or Postgres or DynamoDB to perform SQL.',
    email: 'hr@iqubeinc.com',
  },
  {
    id: 'JB13002',
    title: 'C#/.NET Developer',
    postedDate: 'January 24, 2025',
    description: 'Skills Required:\n3+ years strong development background in C#/.NET, NET CORE and Spring Boot. Experience in DevOps Toolchain methodologies, including TDD (test-driven development), Continuous Integration, and Continuous Deployment. Experience using SQL, ADF. Open Source development experience will be an added advantage. Knowledge with Azure cloud environment development and deployment. Knowledge of backend development using one of the following technologies: C#/.Net.',
    email: 'hr@iqubeinc.com',
  },
  {
    id: 'JB13003',
    title: '.NET Web Developer III/Application Architect',
    postedDate: 'January 27, 2025',
    description: 'Top 3-4 desired skills required for the position:\nExperience as an application architect (Desired)\nMicrosoft .Net Application development utilizing DB2, SQL Server or similar relational database and Angular.\nExperience with Team Foundation Server/Azure DevOps\nExperience with Ajax, JavaScript, Web Services and HTML\nWill this position have access to FTI (Federal Tax Information)? No\nOn Call hours required? No\nWill the position require any weekend coverage? (IE: weekend maintenance) Yes\nIs this position Remote, Hybrid**, or In Person? Hybrid\n**For Hybrid, please provide a breakdown of Remote % and Onsite % (required): Hybrid (95% remote 5% onsite as needed)\n\nDetailed Job Description:\nThis request is for a Microsoft .NET Web Developer III/Application Architect having experience and knowledge with systems analysis, multi-layered object-oriented design techniques, Microsoft Web applications architecture and development software to be responsible for designing, developing, and supporting web applications in .NET and Angular, pertaining to Employment programs in Wisconsin. This position will support new distributed web-based employment applications along with modifications to existing applications for federally mandated, state budget and administrative projects. In addition, this position will provide support for current employment program applications including Wisconsin Work Programs (WWP) and CARES Worker Web (CWW) for state and agency workers; and ACCESS and MyAccess, our participant facing systems. Project duties will be to work as a .NET web developer and architect as part of a team to develop and maintain employment program applications in a Microsoft environment using web tools and techniques. Project duties will also include analysis, design, coding, testing, quality assurance, development of user documentation and training materials. Priority will be given to candidates with application development experience related to state/federal programs.\n\nQualification Experience\nAnalytical/problem solving skills 8 Years\nExcellent oral and written communication skills 8 Years\nApplication Development and Support of IIS/ASP.Net/MVC/DB2/Oracle Server Based Systems 8 Years\nExperience using Angular Framework 3 years\nEvaluate and recommend programming languages, design tools, application frameworks, and applications 8 Years\nObject-Oriented Analysis, Design, Architecture 8 Years\nIn-Depth Knowledge of System Development Life Cycle Deliverables for each Phase of Development 8 Years\nRequirements Gathering and Analysis 8 Years\nExperience using SQL, SPUFI, IBM Data Studio, FileManager, QMF Tools or Equivalent 3 Years\nExperience creating/using Unit Test, System Test, and User Acceptance Test Plans 8 Years\n.NET (MS), ASP.NET, XML/XSL/XSLT 8 Years\nCrystal Reports, C Sharp, Regular Expressions, Team Foundation Server 2 Years\nWeb Services/Web Communication Foundation 5 Years\nAJAX, Javascript, JQuery and JQuery UI 5 years\nChange/Project Management 4 Years\nTechnical Writing and Documentation 8 Years',
    email: 'hr@iqubeinc.com',
  },

  {
    id: 'JB13004',
    title: 'SOFTWARE ENGINEER',
    postedDate: 'Jan 3, 2025',
    description: 'Responsible for developing software scripts using Perl, Python, and TCL to automate tasks involving the entire implementation and sign-off of systems. This process also involves supervising and making key decisions in the entire physical design flow. Develop scripts for design analysis, area estimation, and floor planning. Write software algorithms for the implementation of design steps: synthesis, floor planning, placement of modules, clock tree synthesis (CTS), and routing through automation scripts. Develop TCL scripts for sign-off activities such as Design Rule Checks (DRC), Layout Versus Schematic (LVS), Formal Verification (FV), Chip-Level Power (CLP), Power Distribution Network (PDN), and Timing Verification. N-1 years of experience required. Design and implementation of digital components of high-speed designs. Lead the physical implementation flows through automation using scripting software like Python, Perl, and TCL. Develop sign-off flows for quality checks to ensure high yield and reliability of products. Provide detailed architectural artifacts and roadmap for next-generation products and System-on-Chips (SoCs).',
    email: 'hr@iqubeinc.com',
  },


];

const JobList = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileselected, setFileSelected] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showForm, setShowForm] = useState(false);

  
  const [applicantName, setApplicantName] = useState('');
  const [applicantEmail, setApplicantEmail] = useState('');
  const [applicantPhone, setApplicantPhone] = useState('');

  const [msg, setMsg] = useState("");

  //job details
  const [jobdesc, setJobDesc] = useState("");
  const [email, setEmail] = useState("");
  const [jobid, setJobId] = useState("");
  const location = useLocation();

  const openJobDetailsModal = (job , event) => {
    event.preventDefault();
    console.log('Job details modal opened:', job);

    setSelectedJob(job);
    setIsModalOpen(true);

  };

  const closeJobDetailsModal = () => {
    setSelectedJob(null);
    setIsModalOpen(false);

  };

  const showModal = (description, email, jobid) =>{
    setJobDesc(description);
    setEmail(email);
    setJobId(jobid);
    setShowForm(true);
  }
  const handleApplySubmit = async () => {
    try {
      const formData = new FormData();
      formData.append('resume', selectedFile);
      formData.append('description', jobdesc);
      formData.append('jobId', jobid);
      formData.append('email', email);
      formData.append('name', applicantName);
      formData.append('status', 'SUBMITTED');
      formData.append('applicantEmail', applicantEmail);
      formData.append('applicantPhone', applicantPhone);


  const companyName = new URLSearchParams(location.search).get('company');
  formData.append('companyName', companyName);


      const response = await fetch(BASE_URL+'/apply', {
        method: 'POST',
        body: formData,
      });
   console.log(response.ok);
      if (response.ok) {
        setShow(true);
        setShowForm(false);
        setMsg('Application Submitted successful');
      } else {
        setShow(true);
        setShowForm(false);
        setMsg('Application failed:', response.statusText);
      }
    } catch (error) {
     // console.error('Application failed:', error.message);
    }
  };

  const handleClose =() =>{
    setShow(false);
    setShowForm(false);
  }
  return (
    <div className="job-list-container">
    <h2>Available Jobs</h2>
    {msg && <Alert variant="success">{msg}</Alert>}
    <ul className="job-list">
      {jobs.map((job) => (
        <li key={job.id} className="job-item">
          <div className="job-description">
            <h3>{job.title}</h3> <div className="d-flex justify-content-between align-items-center">
                <p>
{job.description.substring(0,200)}... <a href="#!" onClick={(event) => openJobDetailsModal(job, event)}>See Details</a></p>
              </div>
          </div>
          <div className="job-details d-flex align-items-center">
              <div>
                <p><b>Job id:</b> {job.id}</p>
                {/* <p><b>Email: </b>{job.email}</p> */}
                <p><b>Posted Date:</b> {job.postedDate}</p>
                <input
                  type="file"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </div>
            </div>
            <button disabled={!selectedFile} onClick={() => showModal(job.description, job.email, job.id)}>Apply</button>
          {/* <button onClick={() => applyForJob(job.description, job.email, job.id)}>Apply</button> */}
          <hr />
        </li>
      ))}
    </ul>

    <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpen ? 'block' : 'none' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{selectedJob ? selectedJob.title : ''}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeJobDetailsModal}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{selectedJob ? selectedJob.description : ''}</p>
              {/* <p>Email: {selectedJob ? selectedJob.email : ''}</p> */}
            </div>
          </div>
        </div>
      </div>
      <Modal show={showForm} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Success!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{msg}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>

    <Modal show={showForm} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Apply for Job</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                value={applicantName}
                onChange={(e) => setApplicantName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={applicantEmail}
                onChange={(e) => setApplicantEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter your phone number"
                value={applicantPhone}
                onChange={(e) => setApplicantPhone(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleApplySubmit}>
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );}

export default JobList;
